import styled from '@emotion/styled';
import { Chip } from '@material-ui/core';
import { CardLayout } from 'shared/components/layouts';

// Container

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

// Content

export const Content = styled(CardLayout.Content)`
  display: block;
`;

// LegacyDate

export const LegacyDate = styled(Chip)`
  margin-right: 0.5rem;
`;

LegacyDate.defaultProps = {
  size: 'small',
  color: 'secondary',
};
